import classnames from "classnames/bind";
import styles from "../introduce.module.scss";
const cx = classnames.bind(styles);

const Banner = () => {

	return (
		<div className={cx('bannerWrap')}>
			<div className={cx('banner')}>
				<div className={cx('bannerTextArea')}>
					<span className={cx('bannerDesc')}>공평 기회, 공정 평가, 평등 세상을 위해</span>
					<div className={cx('bannerTitleWrap')}>
						<span className={cx('bannerTitle')}>잡다는 스펙이 아닌</span>
						<span className={cx('bannerTitle', 'bold')}>역량 중심 취업을<br />지향합니다.</span>
					</div>
				</div>
			</div>
		</div>
	)
};

export default Banner;
